import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilHome,
  cilNotes,
  cilCheckCircle,
  cilTruck,
  cilStorage,
  cilColorBorder,
  cilIndustry,
  cilMoney,
  cilGrid,
  cilFactorySlash,
  cilObjectGroup,
  cilSpeedometer,
  cilAddressBook,
  cilUser,
  cilStorage as cilStock,
  cibCodesandbox,
} from '@coreui/icons'

import { CNavItem, CNavGroup } from '@coreui/react'
import './_nav.scss'

const getNav = (t) => [
  {
    component: CNavItem,
    name: t('home'),
    to: '/home',
    icon: <CIcon icon={cilHome} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavItem,
    name: t('customers'),
    to: '/customers',
    icon: <CIcon icon={cilAddressBook} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavItem,
    name: t('suppliers'),
    to: '/suppliers',
    icon: <CIcon icon={cilFactorySlash} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavItem,
    name: t('samples'),
    to: '/samples',
    icon: <CIcon icon={cilNotes} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavItem,
    name: t('weave'),
    to: '/weave',
    icon: <CIcon icon={cilGrid} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavItem,
    name: t('products'),
    to: '/products',
    icon: <CIcon icon={cibCodesandbox} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavItem,
    name: t('orders'),
    to: '/orders',
    icon: <CIcon icon={cilNotes} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavItem,
    name: t('stock'),
    to: '/stock',
    icon: <CIcon icon={cilStock} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavItem,
    name: t('shipments'),
    to: '/shipments',
    icon: <CIcon icon={cilTruck} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavItem,
    name: t('users'),
    to: '/users',
    icon: <CIcon icon={cilUser} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-item-main',
  },
  {
    component: CNavGroup,
    name: t('reports'),
    icon: <CIcon icon={cilNotes} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-group-main',
    items: [
      {
        component: CNavItem,
        name: t('customerAgreementReport'),
        to: '/reports/customer-agreement',
        icon: <CIcon icon={cilNotes} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      {
        component: CNavItem,
        name: t('caglikReport'),
        to: '/reports/caglik-reports',
        icon: <CIcon icon={cilColorBorder} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      {
        component: CNavItem,
        name: t('sampleReport'),
        to: '/reports/sample-report',
        icon: <CIcon icon={cilNotes} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
    ],
  },
  {
    component: CNavGroup,
    name: t('definitions'),
    icon: <CIcon icon={cilNotes} customClassName="nav-icon nav-icon-main" />,
    className: 'nav-group-main',
    items: [
      {
        component: CNavItem,
        name: t('orderStatus'),
        to: '/order-status',
        icon: <CIcon icon={cilCheckCircle} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      {
        component: CNavItem,
        name: t('stockStatus'),
        to: '/stock-status',
        icon: <CIcon icon={cilStorage} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      {
        component: CNavItem,
        name: t('shipmentStatus'),
        to: '/shipment-status',
        icon: <CIcon icon={cilTruck} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      // Material definitions stay available in routes/code, but are hidden from navbar.
      // {
      //   component: CNavItem,
      //   name: t('material'),
      //   to: '/material',
      //   icon: <CIcon icon={cilLayers} customClassName="nav-icon nav-icon-sub" />,
      //   className: 'nav-item-sub',
      // },
      {
        component: CNavItem,
        name: t('yarn'),
        to: '/yarn',
        icon: <CIcon icon={cilFactorySlash} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      // {
      //   component: CNavItem,
      //   name: t('weave'),
      //   to: '/weave',
      //   icon: <CIcon icon={cilGrid} customClassName="nav-icon nav-icon-sub" />,
      //   className: 'nav-item-sub',
      // },
      {
        component: CNavItem,
        name: t('color'),
        to: '/color',
        icon: <CIcon icon={cilColorBorder} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      {
        component: CNavItem,
        name: t('unit'),
        to: '/unit',
        icon: <CIcon icon={cilIndustry} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      {
        component: CNavItem,
        name: t('composition'),
        to: '/composition',
        icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      {
        component: CNavItem,
        name: t('currency'),
        to: '/currency',
        icon: <CIcon icon={cilMoney} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      {
        component: CNavItem,
        name: t('weaveType'),
        to: '/weavetype',
        icon: <CIcon icon={cilObjectGroup} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
      {
        component: CNavItem,
        name: t('supplierType'),
        to: '/suppliertype',
        icon: <CIcon icon={cilObjectGroup} customClassName="nav-icon nav-icon-sub" />,
        className: 'nav-item-sub',
      },
    ],
  }
]

export default getNav